module.exports = __webpack_public_path__ + "static/media/nav_logo_bottom.468a0818.png";